module.exports = __webpack_public_path__ + "static/media/immotech-news-mobile.356f09b7.png";